<template>
    <div>
        <CommonPopupFrame :changeHeight="542" :changeHeightUnit="'px'" :changeBottom="0" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction">
            <!-- <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div> -->
            <div style="margin-top: 16px; padding: 0 18px; display: flex; justify-content: space-between; align-items: center; position: relative">
                <div style="font-weight: 700; line-height: 24px;" @click="closeCompleteAction">
                    닫기
                </div>
                <div @click="modifyIntro" style="font-weight: 700; color: var(--color-main);">저장</div>
                <!-- <div style="font-weight: 700; position: absolute; left: 50%; transform: translateX(-50%)">멤버톡 이름 바꾸기</div> -->
            </div>
            <div style="flex: 1; padding: 0 12px; margin-top: 40px;">
                <div style="margin-bottom: 6px;">
                    <div style="font-weight: 700; font-size: 14px; margin-bottom: 12px;">{{ isCoach ? '채팅방 설명' : '멤버톡 소개' }}</div>
                    <input @input="handleIntroLength" v-model="intro" style="width: 100%; border: none; background-color: #f5f5f5; padding: 12px; border-radius: 12px; outline: none;" placeholder="소개" type="text">
                </div>
                <div style="float: right; color: #bbbbbb; font-size: 12px; font-weight: 700;">{{ intro.length }}/200</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame';
import ResponseCode from '../../../ResponseCode';
export default {
    name: 'ModifyMemberTalkIntro',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeCompleteAction: {
            type: Function,
            default: () => { }
        },
        memberTalkDetail: {
            type: Object,
            default: () => { }
        },
        memberTalkIdx: {
            type: [Number, String],
            default: -1
        },
        isCoach: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            intro: null
        }
    },
    created() {
        this.intro = this.memberTalkDetail.introduce
        this.modifyIntro = this.$Once(this.modifyIntro)
    },
    methods: {
        async modifyIntro() {
            if (this.intro === '' || this.intro === null) {
                this.$GlobalStore.showAlert('멤버톡 소개를 입력해주세요')
                return
            }
            const formData = new FormData()
            formData.append('mode', 'update')
            formData.append('introduce', this.intro)
            formData.append('join_idx', this.memberTalkIdx)

            const res = await this.$Axios.post('/api/join/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })

            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeCompleteAction('intro', this.intro)
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        handleIntroLength() {
            if (this.intro.length > 200) {
                this.intro = this.intro.slice(0, 200)
            }
        }
    },
    watch: {
        isOpen(newValue) {
            if (!newValue) {
                this.intro = this.memberTalkDetail.introduce
            }
        }
    },
}
</script>

<style scoped></style>